export default __webpack_public_path__ + "static/media/defi.a99f9c9b.png";